// ── Math ─────────────────────────────────────────────────────
export const DEG_TO_RAD = Math.PI / 180;
export const RAD_TO_DEG = 180 / Math.PI;

// ── Time ─────────────────────────────────────────────────────
export const MS_PER_DAY = 86_400_000;
export const MS_PER_HOUR = 3_600_000;
export const MS_PER_MINUTE = 60_000;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_MINUTE = 60;
export const HOURS_IN_HALF_DAY = 12;

// ── Julian date conversion ──────────────────────────────────
export const UNIX_EPOCH_JULIAN_DATE = 2_440_587.5;
export const J2000_JULIAN_DATE = 2_451_545.0;
export const DAYS_PER_JULIAN_CENTURY = 36_525;
